SmallWinController = {};
SmallWinController.lowWinAwardTextBacking = undefined;
SmallWinController.emitter = undefined;
SmallWinController.lowWinContainer = undefined;
SmallWinController.smallWinTimeline = undefined;
SmallWinController.finishTween = undefined;

SmallWinController.initialise = function () {
  SmallWinController.lowWinAwardTextBacking = resourceManager.get("smallWin");
  SmallWinController.lowWinAwardTextBacking.visible = false;
  SmallWinController.smallWinAward = resourceManager.get("smallWin:smallWinAmountText");
  SmallWinController.smallWinAward.visible = false;
  SmallWinController.freeSpinsEndCallback = undefined;

  const xPos = layoutController.getCurrentLayoutProperties().width / 2;
  const yPos =
    layoutController.getCurrentLayoutProperties().height - layoutController.getCurrentLayoutProperties().height / 5;
  SmallWinController.lowWinAwardTextBacking.position = { x: xPos, y: yPos };

  SmallWinController.emitter = particleManager.createEmitter(
    "smallWinEmmitter",
    "smallWinParticlesContainer",
    0,
    0,
    false
  );
  SmallWinController.emitter.position = {
    x: layoutController.getCurrentLayoutProperties().width / 2,
    y: layoutController.getCurrentLayoutProperties().height + 50,
  };
  SmallWinController.emitter.particleEmitter.emit = false;
  SmallWinController.emitter.visible = false;
};

SmallWinController.doSmallWin = function (amountWon, winCapped) {
  SmallWinController.finishTween = undefined;
  SmallWinController.smallWinTimeline = undefined;
  Reflex.registerEventHandler("orientationChange", SmallWinController.orientationChange.bind(this));

  let isBigWin = gameController.bigWin.willTriggerBigWin(amountWon, gameController.globalHelperGetStake());
  let callback = SmallWinController.finishSmallWin.bind(this);

  if (isBigWin) {
    callback = SmallWinController.transitionIntoBigWin.bind(this);
    this.transitionIntoBigWin(winCapped);
  } else {
    SmallWinController.lowWinAwardTextBacking.visible = true;
    SmallWinController.smallWinAward.visible = true;
    SmallWinController.emitter.particleEmitter.emit = false;
    SmallWinController.emitter.visible = false;
    SmallWinController.smallWinIntro(amountWon, callback);
  }
};

SmallWinController.smallWinIntro = function (amountWon, callback) {
  SmallWinController.lowWinAwardTextBacking.scale = 0;
  SmallWinController.orientationChange();
  SmallWinController.smallWinTimeline = gsap
    .timeline({ paused: false })
    .to(SmallWinController.lowWinAwardTextBacking.scale, {
      ease: "bounce.in",
      duration: 0.2,
      x: 0.8,
      y: 0.8,
      onComplete: () => {
        soundManager.play("boardAppear");
        SmallWinController.countUpWinningsTween(0, amountWon, callback);
      },
    });
};

SmallWinController.countUpWinningsTween = function (countFrom, countTo, callback) {
  var counter = { var: countFrom };
  const countDuration = 1.5;
  let emitterStartCallback = SmallWinController.playEmitter.bind(this);

  let countUpTween = gsap.to(counter, 1, {
    var: countTo,
    duration: countDuration,
    ease: Circ.easeOut,
    onStart: () => {
      soundManager.play("coinCountUpLoop");
    },
    onUpdate: () => {
      SmallWinController.smallWinAward.setText(gdk.formatCurrency(counter.var));
      if (countUpTween.progress() > 0.75 && emitterStartCallback !== undefined) {
        emitterStartCallback();
        emitterStartCallback = undefined;
      }
    },
    onComplete: () => {
      soundManager.stop("coinCountUpLoop");
      soundManager.play("coinCountUpEnd");
      callback();
    },
  });
};

SmallWinController.playEmitter = function () {
  SmallWinController.emitter.particleEmitter.emit = true;
  SmallWinController.emitter.visible = true;
};

SmallWinController.transitionIntoBigWin = function (winCapped) {
  SmallWinController.lowWinAwardTextBacking.visible = false;
  SmallWinController.smallWinAward.visible = false;

  gameController.bigWin.start(
    gameController.totalWinnings,
    winCapped,
    null,
    null,
    function () {
      gameController.bigWinDone();
    },
    "basegame"
  );
};

SmallWinController.finishSmallWin = function () {
  SmallWinController.finishTween = gsap
    .timeline({ paused: false })
    .to(SmallWinController.lowWinAwardTextBacking.position, {
      ease: "power.in",
      duration: 0.75,
      y: SmallWinController.lowWinAwardTextBacking.position.y - 25,
    })
    .to(SmallWinController.lowWinAwardTextBacking.position, {
      ease: "power.out",
      duration: 0.5,
      y: layoutController.getCurrentLayoutProperties().height + 500,
      onComplete: () => {
        SmallWinController.lowWinAwardTextBacking.visible = false;
        gameController.bigWinDone();
      },
    });
  Reflex.deregisterEventHandler("orientationChange", SmallWinController.orientationChange.bind(this));
};

SmallWinController.orientationChange = function () {
  const xPos = layoutController.getCurrentLayoutProperties().width / 2;
  //switch ypos based off layout
  let yPos =
    layoutController.getCurrentLayoutProperties().height - layoutController.getCurrentLayoutProperties().height / 5;
  switch (layoutController.getCurrentLayout()) {
    case "landscape_default":
      yPos =
        layoutController.getCurrentLayoutProperties().height - layoutController.getCurrentLayoutProperties().height / 5;
      break;
    case "landscape_mobile": {
      yPos =
        layoutController.getCurrentLayoutProperties().height - layoutController.getCurrentLayoutProperties().height / 5;
      break;
    }
    case "portrait_default": {
      yPos =
        layoutController.getCurrentLayoutProperties().height -
        layoutController.getCurrentLayoutProperties().height / 2.5;
      break;
    }
    case "portrait_mobile": {
      yPos =
        layoutController.getCurrentLayoutProperties().height -
        layoutController.getCurrentLayoutProperties().height / 2.5;
      break;
    }
  }

  layoutController.getCurrentLayoutProperties().height - layoutController.getCurrentLayoutProperties().height / 3;
  SmallWinController.lowWinAwardTextBacking.position = {
    x: xPos,
    y: yPos,
  };

  if (SmallWinController.smallWinTimeline !== undefined) {
    if (SmallWinController.finishTween !== undefined) {
      if (SmallWinController.finishTween.progress() >= 0.75) {
        SmallWinController.finishTween.progress(1);
      } else {
        SmallWinController.finishTween.seek(0.75);
      }
    } else {
      SmallWinController.finishSmallWin();
    }
  }

  SmallWinController.emitter.position = {
    x: layoutController.getCurrentLayoutProperties().width / 2,
    y: layoutController.getCurrentLayoutProperties().height + 50,
  };
};
